module.exports = __webpack_public_path__ + "media/images/happy-city-index-logo-76b03f9a5ca41f638ef0d843898c3d13.png";